const state = {
  teams: null,
  team: null,
  teamsPath: ''
}

const getters = {
  teamsPath: state => state.teamsPath,
  teams: state => state.teams,
  team: state => state.team
}

const actions = {
  setTeamsPath ({ rootState, commit, state }) {
    const { self } = rootState
    const { domainsPath } = self
    const { team } = state
    commit('SET_TEAMS_PATH', `${domainsPath}/teams/${team.id.numberStr}`)
  }
}

const mutations = {
  SET_TEAMS_PATH (state, teamsPath) {
    state.teamsPath = teamsPath
  },
  SET_TEAMS (state, teams) {
    const { list } = teams
    const team = list[0]
    state.teams = teams
    state.team = team
  },
  SET_TEAM (state, team) {
    state.team = team
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}
